import React, { Component } from "react";
import RegisterEmail from "./registerWithEmail";
import { emailValidation } from "../../../../lib/utils/regex_cheat_sheet";
import Verification from "./verification";
import ProfileComponent from "./profileComplete";
import { otpMobileSign, otpMobileVerify, otpMobileResend } from "../../../../lib/otpsignin";
import commonFunction from "../../../../lib/utils/common.js";
import TooManyAttempts from "../Registration/tooManyAttempts";

class RegisterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.email || "",
      emailError: "",
      currentStep: this.props.initialStep || "email",
      verificationSource: null,
      changeEmailSource: null, 
      otpError: "",
      timer: 0,
      otp: [],
      otpLength: 4,
      customer_id: "",
      isPartiallyRegistered: false,
      // registraion_token: "",
      isCompleteProfile: false,
      otpExpired: false,
      failedAttempts: 0,
      // isFirstName: "",
      // isAccessToken: "",
      // isLoading: true
      loading: false
      
    };
    this.timerInterval = null;
  }

  async componentDidMount() {
    // await this.checkSessionApi();

    // if (this.props.isAccessToken && !this.props.isFirstName) {
    //   this.setState({ currentStep: "profileComplete" });
    // }

    if (this.props.onStepChange) {
      this.props.onStepChange(this.state.currentStep);
    }
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentStep !== this.state.currentStep) {
      if (this.props.onStepChange) {
        this.props.onStepChange(this.state.currentStep);
      }
    }
  }

  startTimer = (durationMs = 180000) => {
    const ms = Number(durationMs) || 0;
    if (ms <= 0) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      this.setState({ timer: 0, otpExpired: true });
      return;
    }

    const durationSec = Math.floor(ms / 1000);
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }

    this.setState({ timer: durationSec, otpExpired: false }, () => {
      this.timerInterval = setInterval(() => {
        this.setState((prev) => {
          if (prev.timer <= 1) {
            if (this.timerInterval) {
              clearInterval(this.timerInterval);
              this.timerInterval = null;
            }
            return { timer: 0, otpExpired: true };
          }
          return { timer: prev.timer - 1 };
        });
      }, 1000);
    });
  };

  formatTimer = (seconds) => {
    const sec = Number(seconds) || 0;
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  // checkSessionApi = async () => {
  //   try {
  //     const res = await checksession();
  //     const session = res;

  //     if (session && session.status === true) {
  //       this.setState({
  //         isAccessToken: session?.accessToken,
  //         isFirstName: session?.first_name,
  //         email: session?.email,
  //         // isLoading: false
  //       });
  //     } 
  //     // else {
  //     //   this.setState({ isLoading: false });
  //     // }
  //   } catch (err) {
  //     console.error("Session check failed:", err);
  //     // this.setState({ isLoading: false });
  //   }
  // };

  handleBack = () => {
    const { currentStep } = this.state;
    if (currentStep === "verification") {
      this.handleChangeStep("email");
    } else if (currentStep === "profileComplete") {
      this.handleChangeStep("verification");
    } else if (currentStep === "changeEmail") {
      this.handleChangeStep("verification");
    } else {
      this.handleChangeStep("email");
    }
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value, emailError: "" });
  };

  handleSendOTP = (type) => {
    this.setState({ loading: true });

    if (!emailValidation.test(this.state.email)) {
      this.setState({ emailError: "Please enter a valid email address.", loading: false });
      return;
    }

    otpMobileSign({ email: this.state.email, type })
      .then((response) => {
        if (response?.status) {
          this.setState({ loading: false });

          const ms = Number(response?.data?.resend_timer) || 0;
          this.startTimer(ms);

          const otpLength = response?.data?.otp_length || 4;
          this.setState({
            emailError: "",
            currentStep: "verification",
            customer_id: response?.data?._id,
            otpLength,
            otp: Array(otpLength).fill(""),
            otpError: ""
          });
        } else {
          if(response?.error?.type === "RESEND_OTP_LIMIT_EXCEEDED") {
            this.setState({ currentStep: "tooManyAttempts", loading: false });
            this.startTimer(60000 * response?.error?.resend_after_minutes);
          }
          console.log("Error sending OTP");
          this.setState({ otpError: "Could not send OTP. Please try again." });
        }
      })
      .catch((err) => {
        console.error("sendOTP error:", err);
        this.setState({ loading: false });
        this.setState({ otpError: "Could not send OTP. Please try again." });
      });
  };

  handleOtpChange = (index, value) => {
    if (index === null || index === undefined) {
      if (Array.isArray(value)) {
        this.setState({ otp: value, otpError: "" });
      }
      return;
    }

    const otp = Array.from(this.state.otp);
    if (otp.length < this.state.otpLength) {
      otp.length = this.state.otpLength;
      for (let i = 0; i < this.state.otpLength; i++) {
        if (otp[i] === undefined) otp[i] = "";
      }
    }
    if (index < 0 || index >= this.state.otpLength) return;

    otp[index] = value;
    this.setState({ otp, otpError: "" });
  };

handleChangeStep = (nextStep) => {
  this.setState((prev) => {
    let update = { currentStep: nextStep };


    if (nextStep === "changeEmail") {
      update.changeEmailSource = prev.currentStep;
    }


    if (
      nextStep === "verification" &&
      prev.verificationRoot === null &&
      prev.currentStep !== "changeEmail"
    ) {
      update.verificationRoot = prev.currentStep;
    }


    if (prev.currentStep === "changeEmail" && nextStep === "verification") {
      update.currentStep = prev.changeEmailSource || "email";
      update.changeEmailSource = null;
    }

    if (prev.currentStep === "verification" && nextStep === "email") {
      if (prev.verificationRoot === "profileComplete") {
        update.currentStep = "profileComplete";
      }
      update.verificationRoot = null;
    }

    return update;
  });
};



  onOtpSend = () => {
    this.setState({ loading: true });
    const otpValue = this.state.otp.map((digit) => digit || "").join("");
    otpMobileVerify({ email: this.state.email, otp: otpValue, customer_id: this.state.customer_id })
      .then((response) => {
        if (response?.status) {
          this.setState({ isPartiallyRegistered: response?.data?.is_registered, loading: false });
          // console.log("Verify OTP response:", response.data);
          // const token = response?.data?.registraion_token;
          // if (token) {
          //   commonFunction.setCookie("registration_token", token);
          // }

          const ms = Number(response?.data?.resend_timer);
          if (ms > 0) this.startTimer(ms);

          if (response?.data?.is_registered) {

            // const redirectPath = sessionStorage.getItem("postLoginRedirect") || "/";
            // sessionStorage.removeItem("postLoginRedirect");
            // window.location.href = redirectPath.startsWith("/")
            //   ? redirectPath
            //   : "/";

            // User is already registered - this is a login
            sessionStorage.removeItem("postLoginRedirect");
            window.location.reload();
          } else {
            // User needs to complete profile - this is registration
            this.setState({
              // registraion_token: response?.data?.registraion_token,
              currentStep: "profileComplete"
            });
          }
        } else {

          this.setState({ otpError: this.state.otpExpired ? "OTP expired. Please resend": "Incorrect OTP code. Please try again", loading: false });
        }
      })
      .catch((err) => {
        console.error("verify OTP error:", err);
        this.setState({ currentStep: "otpStatus" });
        // this.setState({ otpError: "Incorrect OTP code. Please try again" });
      });
  };

  setTimer = (time) => {
    if (typeof time === "number") {
      this.setState({ timer: Math.max(0, Math.floor(time)) });
      return;
    }
    if (typeof time === "string") {
      const parts = time.split(":").map((p) => Number(p));
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        this.setState({ timer: parts[0] * 60 + parts[1] });
        return;
      }
    }
  };

  resendOtp = (type) => {
    otpMobileResend({ email: this.state.email, type })
      .then((response) => {
        if (response?.status) {
          const ms = Number(response?.data?.resend_timer) || 0;
          const otpLength = response?.data?.otp_length || this.state.otpLength;

          this.setState({ customer_id: response?.data?._id, otpLength, otp: Array(otpLength).fill(""), otpError: "" }, () => {
            if (ms > 0) this.startTimer(ms);
          });
        } else {
          if(response?.error?.type === "RESEND_OTP_LIMIT_EXCEEDED") {
            this.setState({ currentStep: "tooManyAttempts" });
            this.startTimer(60000 * response?.error?.resend_after_minutes); // 15 minutes
          }
          console.log("Error resending OTP");
          this.setState({ otpError: "Could not resend OTP. Please try again." });
        }
      })
      .catch((err) => {
        console.error("resend OTP error:", err);
        this.setState({ otpError: "Could not resend OTP. Please try again." });
      });
  };

  OtpStatus = () => {
    const styles = this.props.styles;
    return (
      <div className={`${styles.email_otp} ${styles.email_otp__failed}`}>
        <div className={styles.email_otp__hero}>
          <div className={styles.email_otp__hero_icon}>
            <img src="/images/mail_not_sent.svg" alt="Mail Not Sent" />
          </div>
          <p className={styles.email_otp__title}>Could not send OTP</p>
          <p className={styles.email_otp__subtitle}>Please try again later.</p>
          <button
            className={`${styles.email_otp__submit_btn} ${styles.email__failed__otp_btn}`}
            onClick={() => this.handleChangeStep("verification")}
          >
            Retry
          </button>
        </div>
      </div>
    );
  };

  changeEmail = () => {
    let styles = this.props.styles;
    let isMobile = this.props.isMobile;

    return isMobile ? (
      <div className={`${styles.email_otp} ${styles.email_otp__email_change}`}>
        <div className={`${styles.email_otp__content}`}>
          <div className={styles.email_otp__hero}>
            <div className={styles.email_otp__hero_icon}>
              <img src="/images/mail.svg" alt="mail" />
            </div>
            <p className={styles.email_otp__title}>Change Email</p>
            <p className={styles.email_otp__subtitle}>
              Changing Email will cancel the current OTP process
            </p>
          </div>

          <div className={`${styles.email_otp__submit_container} ${styles.email_otp__email_change_btn}`}>
            <button className={`${styles.email_otp__cancel_btn}`} onClick={() => this.handleChangeStep("verification")}>Cancel</button>
            <button className={styles.email_otp__submit_btn} onClick={() => this.handleChangeStep("email")}>Confirm & Change</button>
          </div>
        </div>
      </div>
    ) : (
      <div className={`${styles.email_otp} ${styles.email_otp__email_change}`}>
        <div className={`${styles.email_otp__content}`}>
          <div className={styles.email_otp__hero}>
            <div className={styles.email_otp__hero_icon}>
              <img src="/images/mail.svg" alt="mail" />
            </div>
            <p className={styles.email_otp__title}>Change Email</p>
            <p className={styles.email_otp__subtitle}>
              Changing Email will cancel the current OTP process
            </p>
          </div>

          <div className={`${styles.email_otp__submit_container} ${styles.email_otp__email_change_btn}`}>
            <button className={`${styles.email_otp__cancel_btn}`} onClick={() => this.handleChangeStep("verification")}>Cancel</button>
            <button className={styles.email_otp__submit_btn} onClick={() => this.handleChangeStep("email")}>Confirm & Change</button>
          </div>
        </div>
      </div>
    );
  };

  tooManyAttempts = () => {
    let styles = this.props.styles;
    const { timer } = this.state;

    return (
      <TooManyAttempts
        timer={timer}
        onTryAgain={() => {
          if (timer <= 0) {
            this.setState({ timer: 90000, failedAttempts: 0 });
            this.handleChangeStep("email");
          }
        }}
        startTimer={this.startTimer}
        styles={styles}
      />
    );
  };

  renderSteps() {
    const { currentStep, timer } = this.state;
    let styles = this.props.styles;

    switch (currentStep) {
      case "email":
        return (
          <RegisterEmail
            handleEmailChange={this.handleEmailChange}
            handleSendOTP={this.handleSendOTP}
            email={this.state.email}
            emailError={this.state.emailError}
            styles={styles}
            loading={this.state.loading}
          />
        );
      case "verification":
        return (
          <Verification
            email={this.state.email}
            timer={this.formatTimer(timer)}
            handleInputChange={this.handleOtpChange}
            handleChangeStep={this.handleChangeStep}
            otp={this.state.otp}
            onOtpSend={this.onOtpSend}
            setTimer={this.setTimer}
            styles={styles}
            otpExpired={this.state.otpExpired}
            otpLength={this.state.otpLength}
            otpError={this.state.otpError}
            resendOtp={this.resendOtp}
            loading={this.state.loading}
          />
        );
      case "otpStatus":
        return this.OtpStatus();
      case "changeEmail":
        return this.changeEmail();
      case "tooManyAttempts":
        return this.tooManyAttempts();
      case "profileComplete":
        return (
          <ProfileComponent
            {...this.props}
            email={this.state.email}
            registration_token={commonFunction.getCookie("registration_token")}
            styles={styles}
            IsdCodeDropdownCss={this.props.IsdCodeDropdownCss}
            dropdownStylesTheme12={this.props.data.logincss.dropdownStylesTheme12}
            handleChangeStep={this.handleChangeStep}
          />
        );
      default:
        return (
          <RegisterEmail
            handleEmailChange={this.handleEmailChange}
            handleSendOTP={this.handleSendOTP}
            email={this.state.email}
            emailError={this.state.emailError}
            styles={styles}
            loading={this.state.loading}
          />
        );
    }
  }

  render() {
    let styles = this.props.styles;

    // if (this.state.isLoading) return null;

    if (this.state.currentStep === "changeEmail") {
      return <div className={styles.change__email__wrapper}>{this.renderSteps()}</div>;
    } 
    if (this.state.currentStep === "tooManyAttempts") {
      return <div className={styles.too_many_attempts__wrapper}>{this.renderSteps()}</div>;
    }
    else {
      return <div className={styles.component__wrapper}>{this.renderSteps()}</div>;
    }
  }
}

export default RegisterComponent;